export default __webpack_public_path__ + "static/media/radio-small.e101a042.jpg";